module.exports = __webpack_public_path__ + "img/arrow-img.ef11910a.svg";